export default "__VITE_ASSET__Bq9lkBRu__"